import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { first } from 'rxjs/operators';
import { lastValueFrom } from 'rxjs';
import { authState } from '@angular/fire/auth';
import { BaseInjectorService } from '../base/base-service.injector';
import { AppService } from './../app.service';

@Injectable({
  providedIn: 'root',
})
export class LoginResolverService extends BaseInjectorService {
  constructor(private appService: AppService) {
    super();
  }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    await this.platform.ready();
    return this.appService.getAndSetLanguage();
  }

  isLoggedIn() {
    return lastValueFrom(authState(this.firebaseAuth).pipe(first()));
  }
}
